module.exports = __webpack_public_path__ + "media/trailer.3110089e.mp4";